import React, { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function WaitlistForm({ source = "hero", size = "md" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.post("/waitlist", { email: email.trim(), source });
      setDone(true);
      toast.success("You're on the list!", {
        description: "We'll reach out when your early access is ready.",
      });
      setEmail("");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error("Couldn't add you to the waitlist", {
        description: typeof detail === "string" ? detail : "Please check your email and try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const inputH = size === "lg" ? "h-14" : "h-12";
  const btnH = size === "lg" ? "h-14 px-6 text-base" : "h-12 px-5 text-sm";

  return (
    <form
      onSubmit={submit}
      data-testid={`waitlist-form-${source}`}
      className="flex flex-col sm:flex-row gap-2 w-full"
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        data-testid={`waitlist-email-${source}`}
        className={`flex-1 ${inputH} rounded-md border border-[#e2e8f0] bg-white px-4 text-[#0f172a] placeholder:text-[#94a3b8] focus:outline-none focus:border-[#084392] focus:ring-4 focus:ring-[#084392]/10 transition`}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`waitlist-submit-${source}`}
        className={`${btnH} inline-flex items-center justify-center gap-2 rounded-md bg-[#084392] hover:bg-[#06326e] text-white font-semibold transition disabled:opacity-70`}
      >
        {loading ? (
          <>
            <Loader2 size={16} className="animate-spin" /> Joining
          </>
        ) : done ? (
          <>You&rsquo;re in</>
        ) : (
          <>
            Join Waitlist <ArrowRight size={16} />
          </>
        )}
      </button>
    </form>
  );
}
